var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.block.data.text)?_c('div',{staticClass:"w-mb",class:{
    wrapper: _vm.block.tunes.headerTune !== 'gray-descriptor',
    'entry-body-wide w-mb2': _vm.block.tunes.headerTune == 'gray-descriptor',
  }},[_c('div',{class:{
      wrapper: _vm.block.tunes.headerTune == 'gray-descriptor',
      'tac green': _vm.block.tunes.headerTune == 'green-descriptor',
    }},[_c('div',{class:'h' + _vm.block.data.level,domProps:{"innerHTML":_vm._s(_vm.block.data.text)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }